import * as React from "react"
import { cn } from "@/lib/utils"

export interface EmailIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * Email icon as SVG (envelope symbol)
 *
 * This icon represents email/envelope in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <EmailIcon />
 * <EmailIcon size={16} className="text-gray-500" />
 * ```
 */
export const EmailIcon = React.forwardRef<SVGSVGElement, EmailIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 15 11"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M2.2,10.7c-.7,0-1.2-.2-1.5-.5-.4-.4-.5-.9-.5-1.5V2.2C.1,1.5.3,1,.7.7,1,.3,1.5.1,2.1.1h10.7c.7,0,1.2.2,1.5.5.4.4.5.9.5,1.5v6.5c0,.7-.2,1.2-.5,1.5-.3.4-.8.5-1.4.5H2.2ZM2.3,9.3h10.5c.2,0,.4,0,.5-.2.1-.1.2-.3.2-.6V2.3c0-.2,0-.4-.2-.5-.1-.1-.3-.2-.5-.2H2.3c-.2,0-.4,0-.5.2s-.2.3-.2.5v6.3c0,.2,0,.4.2.6s.3.2.5.2ZM7.5,7.1c-.2,0-.4,0-.6-.1-.2,0-.4-.2-.6-.4L.9,1.7l.9-.9,5.3,4.8c.2.1.3.2.5.2s.3,0,.5-.2L13.3.9l.9.9-5.4,4.9c-.2.2-.4.3-.6.4-.2,0-.4.1-.6.1ZM1.8,9.7l-.9-.9,4.1-4.1.9.8L1.8,9.7ZM13.2,9.7l-4.1-4.1.9-.8,4.1,4.1-.9.9Z" />
      </svg>
    )
  }
)

EmailIcon.displayName = "EmailIcon"
